import React from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { theme } from "src/styles/theme";
import { css, styled } from "styled-components";

const Container = styled.div<{float?: boolean}>`
    // width: 616px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    z-index: 999999999999999;
    position: relative;
    margin-top: 40px;
    // ${props=>props.float && css `
    //     position: absolute;
    //     left: 40px;
    //     top: 100px;
    // `};
    @media (max-width: ${theme.breakpoints.mobile}px) {
        width: 100%;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        margin-top: 0px;
    } 
`;

const MenuItem = styled.div<{color?: string}>`
    font-family: ${theme.fonts.primary};
    font-weight: ${theme.fontWeights.bold};;
    font-size: ${theme.fontSizes.xl};;
    line-height: 135%;
    letter-spacing: 0%;

    cursor: pointer;
    padding: 5px 0;
    opacity: 0.5;
    transition: opacity 0.2s;
    color: ${props=>props.color || "#FFFFFF"};
    
    &:hover, &.active {
        opacity: 1;
    }
    @media (max-width: ${theme.breakpoints.mobile}px) {
    font-size: 18px;
  }
`;

const SideMenu: React.FC<{activeMenuItem: string, color?: string, float?: boolean,disabledMenu?:string[] }>= ({disabledMenu,activeMenuItem, color, float=false}) => {
    const navigate = useNavigate();
    const isNotPC = useMediaQuery({ maxWidth: theme.breakpoints.maxTablet });
    const navigateTo=(url:string,active:string,menu:string[]=[])=>{
        if(menu.includes(active)) return;
        navigate(url)
    }
    return (
    <Container float={float}>
        <MenuItem color={color}
        className={activeMenuItem === 'Record' ? 'active' : ''}
        onClick={()=>{navigateTo("/qcast/respond","Record",disabledMenu?disabledMenu:[])}}
        
        >
        Record
        </MenuItem>
        {
            !isNotPC&&(
                <MenuItem  color={color} 
                className={activeMenuItem === 'Edit' ? 'active' : ''}
                onClick={()=>{navigateTo("/qcast/edit","Edit",disabledMenu?disabledMenu:[])}}
                >
                Edit
                </MenuItem>
            )
        }
       
        <MenuItem  color={color} 
        className={activeMenuItem === 'Review' ? 'active' : ''}
        onClick={()=>{navigateTo("/qcast/review","Review",disabledMenu?disabledMenu:[])}}
        >
        Review
        </MenuItem>
    </Container>
    )
}

export default SideMenu;